module.exports = __webpack_public_path__ + "img/header_img_zoomed.53455f0c.png";